/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsListUl: {
  name: 'list-ul';
  data: string;
} = {
  name: 'list-ul',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-2a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H8Zm0 5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H8Zm-1 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm-2-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
